<table class="table">
  <thead>
    <th>Estado</th>
    <th>Nombre</th>
    <th>SKU</th>
    <th>EAN</th>
    <th>Producto</th>
    <th>Unidad</th>
    <th *ngIf="showOptions"></th>
  </thead>

  <tbody>
    <tr *ngFor="let item of skus">

      <!-- Estado -->
      <td>
        <div *ngIf="item.status === 'ACTIVE'" class="active-container">
          <p>ACTIVO</p>
        </div>
        <div *ngIf="item.status === 'INACTIVE'" class="inactive-container">
          <p>INACTIVO</p>
        </div>
      </td>

      <!-- Nombre -->
      <td>{{ item.name }}</td>

      <!-- SKU -->
      <td>{{ item.sku }}</td>

      <!-- EAN -->
      <td>{{ item.ean }}</td>

      <!-- Producto -->
      <td>{{ item.productName }}</td>

      <!-- Unidad -->
      <td>{{ item.unitLabel }}</td>

      <!-- Opciones -->
      <td *ngIf="showOptions">
        <div class="options opt">
          <img
            #imageElement
            src="assets/images/ico-options.svg"
            (click)="toggleOptions(imageElement)"
            class="opt"
          />
          <div class="box d-none opt">
            <p class="opt" (click)="editar(item.id)">
              Editar SKU
            </p>
            <p class="opt" (click)="requestDelete.emit(item)">
              Eliminar SKU
            </p>
          </div>
        </div>
      </td>

    </tr>
  </tbody>
</table>
